<span [ngClass]="getCssClassesForStatus(action)">
    {{ "actions.status." + action.statut | translate }}
    <span [ngSwitch]="action.statut">
        <i *ngSwitchCase="actionStatus.inProgress" class="fas fa-arrow-right"></i>
        <i *ngSwitchCase="actionStatus.done" class="fas fa-check"></i>
    </span>
</span>
